import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Phone, MessageSquare } from 'lucide-react'
import { siteData } from '../data/siteData'

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false)
  const [inContact, setInContact] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      const contactSection = document.getElementById('contact')

      setVisible(scrollY > 600)

      if (contactSection) {
        const rect = contactSection.getBoundingClientRect()
        setInContact(rect.top < window.innerHeight && rect.bottom > 0)
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <AnimatePresence>
      {visible && !inContact && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 20, stiffness: 300 }}
          className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-steel/95 backdrop-blur-xl border-t border-military/30 px-4 py-3"
        >
          <div className="flex gap-3 max-w-lg mx-auto">
            <a
              href={`tel:${siteData.phone}`}
              className="flex-1 flex items-center justify-center gap-2 py-3 bg-steel-lighter border border-chrome/20 rounded-sm text-bone font-subheading font-semibold text-sm uppercase tracking-wide hover:bg-steel-light transition-colors"
            >
              <Phone size={16} />
              Zadzwoń
            </a>
            <button
              onClick={() => {
                const el = document.getElementById('contact')
                el?.scrollIntoView({ behavior: 'smooth' })
              }}
              className="flex-1 flex items-center justify-center gap-2 py-3 bg-military-light text-bone font-subheading font-bold text-sm uppercase tracking-wide rounded-sm hover:bg-military-glow transition-colors"
            >
              <MessageSquare size={16} />
              Zarezerwuj
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
